import {
  useMutation,
  useQuery,
  useQueryClient,
  UseMutationOptions,
  UseQueryOptions,
} from "@tanstack/react-query";
import {
  pipelineService,
  type PipelineExecutionStatus,
  type StartPipelineBody,
} from "../../services/pipeline.service";

export const pipelineKeys = {
  all: ["pipeline"] as const,
  status: (executionId: number) =>
    [...pipelineKeys.all, "status", executionId] as const,
};

export function usePipelineExecutionStatus(
  executionId: number | null,
  options?: Omit<
    UseQueryOptions<PipelineExecutionStatus, Error>,
    "queryKey" | "queryFn"
  >,
) {
  return useQuery<PipelineExecutionStatus, Error>({
    queryKey: executionId
      ? pipelineKeys.status(executionId)
      : [...pipelineKeys.all, "status", "idle"],
    queryFn: () => pipelineService.getStatus(executionId!),
    enabled: executionId != null && executionId > 0,
    staleTime: 0,
    ...options,
  });
}

export function useStartPipeline(
  options?: UseMutationOptions<number, Error, StartPipelineBody>,
) {
  const queryClient = useQueryClient();
  return useMutation<number, Error, StartPipelineBody>({
    mutationFn: (body) => pipelineService.start(body),
    onSuccess: (executionId) => {
      void queryClient.invalidateQueries({
        queryKey: pipelineKeys.status(executionId),
      });
    },
    ...options,
  });
}
